import { NgModule } from "@angular/core";
import { VariableListModule } from "./list/variable-list.module";
import { VariableRoutingModule } from "./variable.routing";

@NgModule({
    imports: [VariableRoutingModule, VariableListModule],
})
export class VariableModule {}
